import { Container } from '@cgs/wge';
import { TRIFECTA_SDK_ADAPTER_TOKEN, TrifectaSDKAdapter } from '../../../sdk/trifecta-sdk.adapter';

export const TRIFECTA_FREE_SPINS_COUNT_COMPONENT_TOKEN = Symbol(
  'TRIFECTA_FREE_SPINS_COUNT_COMPONENT_TOKEN'
);

export abstract class TrifectaFreeSpinsCountComponent {
  protected readonly container: Container;
  protected readonly trifectaSDKAdapter: TrifectaSDKAdapter;

  protected isFreeSpinsVisible: boolean = false;
  protected freeSpinsCount: number = 0;

  protected constructor(container: Container) {
    this.container = container;
    this.trifectaSDKAdapter = container.resolve<TrifectaSDKAdapter>(TRIFECTA_SDK_ADAPTER_TOKEN);
  }

  protected showFreeSpins(): void {
    if (!this.isFreeSpinsVisible) {
      this.trifectaSDKAdapter.showFreeSpins();
      this.setFreeSpins(0);
      this.isFreeSpinsVisible = true;
    }
  }

  protected hideFreeSpins(): void {
    if (this.isFreeSpinsVisible) {
      this.trifectaSDKAdapter.hideFreeSpins();
      this.setFreeSpins(0);
      this.isFreeSpinsVisible = false;
    }
  }

  protected incrementFreeSpins(count: number): void {
    this.trifectaSDKAdapter.incrementFreeSpins(count);
    this.freeSpinsCount += count;
  }

  protected decrementFreeSpins(count: number): void {
    this.trifectaSDKAdapter.decrementFreeSpins(count);
    this.freeSpinsCount -= count;
  }

  protected setFreeSpins(count: number): void {
    const delta = count - this.freeSpinsCount;

    if (delta > 0) {
      this.trifectaSDKAdapter.incrementFreeSpins(delta);
    } else if (delta < 0) {
      this.trifectaSDKAdapter.decrementFreeSpins(-delta);
    }

    this.freeSpinsCount = count;
  }
}
